import { useCallback, useState } from "react";
import { MapErrorId } from "../../../utils/maps/MapConstants";

export const useMapFailures = () => {
  const [mapApiFailures, setMapApiFailures] = useState<MapErrorId[]>([]);

  const handleMapApiFailure = useCallback(
    (errorId: MapErrorId, isReset = false) => {
      setMapApiFailures((current) => {
        if (isReset) {
          if (!current.includes(errorId)) {
            return current;
          }
          return current.filter((id) => id !== errorId);
        }
        return current.includes(errorId) ? current : [...current, errorId];
      });
    },
    []
  );

  return { mapApiFailures, handleMapApiFailure };
};
